import React, { useEffect, useState } from "react";
import { UTILS } from "../../constants";
export const Cards = ({ column }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <div className="mt-0 task-header menu-card-header text-uppercase">
        <div className="app-card">
          <h3 className="app-card-heading">
            {column.title} {UTILS.Env === "local" ? ` [${column.id}] ` : null}
          </h3>
          <div className="dropdown">
            <button
              className="app-card-edit d-none"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={isOpen ? close : open}
            >
              <span className="material-symbols-outlined">more_horiz</span>
            </button>
            {isOpen && (
              <div className="dropdown-menu add-member-drop main-card-drop current-step">
                <div class="add-member buttons-container">
                  <button
                    class="close-btn-pop close-member"
                    onclick="closeDiv()"
                  >
                    <span class="material-symbols-outlined">close</span>
                  </button>
                  <h4 class="mem-heading">List actions</h4>
                  <ul class="drop-list-action">
                    <li>
                      <a href="javascript:void(0);">Add Card...</a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dynamicBtn"
                        data-target="copy-drop-list"
                      >
                        Copy List...
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dynamicBtn"
                        data-target="move-drop-list"
                      >
                        Move List...
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Watch</a>
                    </li>
                  </ul>
                  <h5 class="main-card-heading">Automation</h5>
                  <ul class="drop-list-action">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dynamicBtn"
                        data-target="newrule-drop-list"
                      >
                        When a card is added to the list...
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">
                        Every day, sort list by...
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">
                        Every Monday, sort list by...
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">Create a rule...</a>
                    </li>
                  </ul>
                  <ul class="drop-list-action">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dynamicBtn"
                        data-target="move-all-drop-list"
                      >
                        Move all cards in this list...
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dynamicBtn"
                        data-target="archive-all-drop-list"
                      >
                        Archive all cards in this list...
                      </a>
                    </li>
                  </ul>
                  <ul class="drop-list-action">
                    <li>
                      <a href="javascript:void(0);">Archive this list</a>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
